import React, { useState, useEffect, useMemo } from "react";
import "./Dashboard.css";
import { collection, getDocs} from "firebase/firestore/lite";
import { doc, updateDoc } from "firebase/firestore/lite";
import db from "../../Pages/Components/firebase.config";
import { useNavigate } from "react-router-dom";
import { LuRefreshCw } from "react-icons/lu";
import { Switch } from "@mui/material";
import { GrPrevious, GrNext } from "react-icons/gr";
import * as XLSX from "xlsx";
import { TfiExport } from "react-icons/tfi";
import CircularProgress from "@mui/material/CircularProgress";

const ITEMS_PER_PAGE = 10;

const Dashboard = () => {
  const [applications, setApplications] = useState([]);
  const [contactApplicants, setContactApplications] = useState([]);
  const [showApplications, setShowApplications] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [allContacted, setAllContacted] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [selectedJobRole, setSelectedJobRole] = useState("All");
  const [selectFilter, setSelectFilter] = useState("");
  const [exprienceFilter, setexprienceFilter] = useState("");
  const [gender, setGender] = useState("");
  const [newsletterApplicants, setNewsletterApplicants] = useState([])
  const [showNewsletter, setShowNewsletter] = useState(false);
  const [selectedNewsletter, setSelectedNewsletter] = useState([]);
  const [allNewsletter, setAllNewsletter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportFilter, setExportFilter] = useState("All");

  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  const fetchApplicantsData = async () => {
    try {
      setIsLoading(true);
      const applicantsCollection = collection(db, "applicants");
      const querySnapshot = await getDocs(applicantsCollection);

      const applicantsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      applicantsData.sort((a, b) => {
        return b.appliedOn.toMillis() - a.appliedOn.toMillis();
      });

      setApplications(applicantsData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching applicants: ", error);
      setIsLoading(false);
    }
  };

  const fetchNewsletterDetails = async()=>{
    try{
      const newsLetterData = collection(db, "newsletter_contacts")
      const newsQueryData = await getDocs(newsLetterData);
      const newsletterapplicantsData = newsQueryData.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const parseDateTime = (date, time) => {
        return new Date(`${date} ${time}`);
      };
      const sortedData = newsletterapplicantsData.sort((a, b) => {
        const dateTimeA = parseDateTime(a.date, a.time);
        const dateTimeB = parseDateTime(b.date, b.time);
        return dateTimeB - dateTimeA;
      });
      
      setNewsletterApplicants(sortedData)
    }
    catch(error){
      console.error("Error fetching newsletter details: ", error);
    }
  };

  const filteredApplications = useMemo(() => {
    return applications.filter((application) => {
      const jobRoleCondition =
        selectedJobRole === "All" || application.jobRole === selectedJobRole;

      const statusCondition =
        selectFilter === "" || application.status === selectFilter;
        
      const exprienceCondition =
       exprienceFilter === "" || application.experience === exprienceFilter;

      const genderCondition = gender === "" || application.gender === gender;

      const exportCondition =
        exportFilter === "All" ||
        (exportFilter === "Exported" && application.isExported === true) ||
        (exportFilter === "Unexported" && !application.isExported);

      return (
        jobRoleCondition &&
        statusCondition &&
        exprienceCondition &&
        genderCondition &&
        exportCondition
      );
    });
  }, [
    applications,
    selectedJobRole,
    selectFilter,
    exprienceFilter,
    gender,
    exportFilter,
  ]);

  const fetchContactApplicantsData = async () => {
    try {
      setIsLoading(true);
      const contactApplicantsCollection = collection(db, "contacts");
      const querySnapshot = await getDocs(contactApplicantsCollection);

      const conatctApplicantsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setContactApplications(conatctApplicantsData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching contact applicants: ", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicantsData();
    fetchContactApplicantsData();
  }, []);

  const handleRefresh = async () => {
    setIsRotating(true);
    if (showApplications) {
      await fetchApplicantsData();
    } else if(showNewsletter) {
      await fetchNewsletterDetails();
    } else {
      await fetchContactApplicantsData();
    }
    setIsRotating(false);
  };

  const getRefreshIcon = () => {
    if (isRotating) {
      return <i className="fa fa-spinner fa-spin"></i>;
    } else {
      return <LuRefreshCw />;
    }
  };

  const toggleTable = (e) => {
    if(e.target.checked){
      setShowApplications(true);  
    }else{
      setShowApplications(false);
    }
    setShowNewsletter(false);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const handleCheckboxChange = (id) => {
    const newSelectedApplications = selectedApplications.includes(id)
      ? selectedApplications.filter((appId) => appId !== id)
      : [...selectedApplications, id];
    setSelectedApplications(newSelectedApplications);
  };
  const handleCheckboxNewsletterChange = (id) => {
    const newSelectedApplications = selectedNewsletter.includes(id)
      ? selectedNewsletter.filter((appId) => appId !== id)
      : [...selectedNewsletter, id];
      setSelectedNewsletter(newSelectedApplications);
  };

  const selectAllHandler = () => {
    if (allSelected) {
      setSelectedApplications([]);
    } else {
      const allApplicationIds = filteredApplications.map(
        (application) => application.id
      );
      setSelectedApplications(allApplicationIds);
    }
    setAllSelected(!allSelected);
  };
  
  const selectAllNewsletterHandler = () => {
    if (allNewsletter) {
      setSelectedNewsletter([]);
    } else {
      const allContactIds = newsletterApplicants.map((newsletter) => newsletter.id);
      setSelectedNewsletter(allContactIds);
    }
    setAllNewsletter(!allNewsletter);
  };

  const exportNewsletterSelectedData = () => {
    const selectedData = newsletterApplicants.filter((newsletter) =>
      selectedNewsletter.includes(newsletter.id)
    );
    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Selected Contacts");
    const fileName = `selected_newsletter_applicants.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const handleCheckboxContactChange = (id) => {
    const newSelectedContacts = selectedContacts.includes(id)
      ? selectedContacts.filter((appId) => appId !== id)
      : [...selectedContacts, id];
    setSelectedContacts(newSelectedContacts);
  };

  const selectAllContactHandler = () => {
    if (allContacted) {
      setSelectedContacts([]);
    } else {
      const allContactIds = contactApplicants.map((contact) => contact.id);
      setSelectedContacts(allContactIds);
    }
    setAllContacted(!allContacted);
  };

  const exportSelectedData = async () => {
    const selectedData = applications.filter((application) =>
      selectedApplications.includes(application.id)
    );
    if (selectedData.length === 0) {
      return alert("Select any checkbox");
    }
    
    try {
      // Update isExported field to true for selected applications
      for (const data of selectedData) {
        const candidateRef = doc(db, "applicants", data.id);
        await updateDoc(candidateRef, {
          isExported: true,
          exportedOn: new Date()
        });
      }

      // Refresh applications data
      await fetchApplicantsData();

      // Export to Excel
      const ws = XLSX.utils.json_to_sheet(selectedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Selected Applications");
      XLSX.writeFile(wb, "selected_applications.xlsx");
      setSelectedApplications([]);
      setAllSelected(false);
    } catch (error) {
      console.error("Error exporting data: ", error);
    }
  };
  const exportContactSelectedData = () => {
    const selectedData = contactApplicants.filter((contact) =>
      selectedContacts.includes(contact.id)
    );

    const ws = XLSX.utils.json_to_sheet(selectedData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Selected Contacts");

    XLSX.writeFile(wb, "selected_contacts.xlsx");
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const candidateRef = doc(db, "applicants", id);

      await updateDoc(candidateRef, {
        status: newStatus,
      });

      const updatedApplications = applications.map((application) => {
        if (application.id === id) {
          return { ...application, status: newStatus };
        }
        return application;
      });

      setApplications(updatedApplications);
    } catch (error) {
      console.error("Error updating status: ", error);
    }
  };

  const handleNewsletter = ()=>{
    setShowNewsletter(true); 
    setShowApplications(false); 
    fetchNewsletterDetails();
  }

  function handleCheckedList(value){
    setSelectFilter(value);
    setSelectedApplications([]);
    setAllSelected(false);
  }

  function handleGenderList(value){
    setGender(value);
    setSelectedApplications([]);
    setAllSelected(false);
  }

  function handleExprienceList(value){
    setexprienceFilter(value);
    setSelectedApplications([])
    setAllSelected(false) 
  }
  function handleExportFilter(value) {
    setExportFilter(value);
    setSelectedApplications([]);
    setAllSelected(false);
  }

  return (
    <div className="dashboard-container">
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
      <button className="refresh-button" onClick={handleRefresh}>
        {getRefreshIcon()}
      </button>
      <button className="toggle-button" onClick={(e)=>toggleTable(e)}>
        <Switch defaultChecked />
      </button>
      <button
        onClick={handleNewsletter}
        className="position-relative btn btn-primary rounded-3"
        style={{top:"0",textTransform: "unset", fontSize:"14px"}}
      >
        Newsletter
      </button>
      {showApplications ? (
        <>
          <div className="d-flex justify-content-start mt-2 ms-2">
            <input
              type="radio"
              checked={selectedJobRole === "All"}
              onChange={() => setSelectedJobRole("All")}
            />
            All
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "React Developer"}
              onChange={() => setSelectedJobRole("React Developer")}
            />
            React Js
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Angular Developer"}
              onChange={() => setSelectedJobRole("Angular Developer")}
            />
            Angular Js
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "ASP.NET Developer"}
              onChange={() => setSelectedJobRole("ASP.NET Developer")}
            />
            .Net
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "HR Executive/Intern"}
              onChange={() => setSelectedJobRole("HR Executive/Intern")}
            />
            HR
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={
                selectedJobRole === "Business Development Executive/Trainee"
              }
              onChange={() =>
                setSelectedJobRole("Business Development Executive/Trainee")
              }
            />
            BD
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Graphic Designer"}
              onChange={() => setSelectedJobRole("Graphic Designer")}
            />
            Graphic Designer
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={
                selectedJobRole === "React Native / Android-iOS APP Developer"
              }
              onChange={() =>
                setSelectedJobRole("React Native / Android-iOS APP Developer")
              }
            />
            React Native
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Research Executive"}
              onChange={() => setSelectedJobRole("Research Executive")}
            />
            Research Executive
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Senior SEO Content Writer"}
              onChange={() => setSelectedJobRole("Senior SEO Content Writer")}
            />
            Senior SEO
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Accounts Manager/Executive"}
              onChange={() => setSelectedJobRole("Accounts Manager/Executive")}
            />
            Accounts
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Project Coordinator (Freshers)"}
              onChange={() =>
                setSelectedJobRole("Project Coordinator (Freshers)")
              }
            />
            Project Coordinator
            <input
              type="radio"
              style={{ marginLeft: "10px" }}
              checked={selectedJobRole === "Lead Generation Specialist"}
              onChange={() => setSelectedJobRole("Lead Generation Specialist")}
            />
            Lead Generation Specialist
          </div>
          <div className="d-flex align-items-center mt-2 ms-2 radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="jobRole"
                className="radio-input"
                checked={selectedJobRole === "Technical Recruiter"}
                onChange={() => setSelectedJobRole("Technical Recruiter")}
              />
              <span className="radio-custom"></span>
              Technical Recruiter
            </label>

            <label className="radio-label" style={{ marginLeft: "20px" }}>
              <input
                type="radio"
                name="jobRole"
                className="radio-input"
                checked={selectedJobRole === "HR Manager"}
                onChange={() => setSelectedJobRole("HR Manager")}
              />
              <span className="radio-custom"></span>
              HR Manager
            </label>
          </div>

          <div style={{display:"flex", justifyContent:"right",gap:"1rem"}}>
            <div className="filter">
              <select
                className="filter-section"
                onChange={(e) => handleCheckedList(e.target.value)}
              >
                <option value={""}>Filter By Application Status</option>
                <option value={"Shortlist"}A>Shortlisted Candidate</option>
                <option value={"Reject"}>Rejected Candidate</option>
              </select>
            </div>
            
            <div className="filter">

              {/*Exprience Year filter*/}
              
              <select
                className="filter-section exprience-filter" 
                onChange={(e) => handleExprienceList(e.target.value)}
              >
                <option value={""}>Filter By Experience</option>
                <option value={"lessthan1"}>Less than 1 year</option>
                <option value={"1to2"}>1-2 years</option>
                <option value={"2to3"}>2-3 years</option>
                <option value={"morethan3"}>More than 3 years</option>
              </select>
            </div>
          </div>
          <div className="gender">
            <select
              className="gender-section"
              onChange={(e) => handleGenderList(e.target.value)}
            >
              <option value={""}>Gender</option>
              <option value={"male"}>Male</option>
              <option value={"female"}>Female</option>
            </select>
          </div>
        </>
      ) :
      ("") }

      {showApplications ? (
        <>
          <h2 className="dashboard-h2">
            Job Applications - {filteredApplications.length}
          </h2>
          <div style={{ display: "flex", gap: "1rem" }}>
            <button className="export-button" onClick={exportSelectedData}>
              Candidate Export <TfiExport />{" "}
              <span style={{ marginLeft: "5px" }}>
                {selectedApplications.length > 0
                  ? selectedApplications.length
                  : ""}
              </span>
            </button>
            

            <div className="excel-filter">
              <select
                className="filter-section"
                onChange={(e) => handleExportFilter(e.target.value)}
                value={exportFilter}
              >
                <option value={"All"}>All Data</option>
                <option value={"Exported"}>Exported Data</option>
                <option value={"Unexported"}>Unexported Data</option>
              </select>
            </div>
          </div>         
          <table className="applications-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={selectAllHandler}
                    checked={allSelected}
                  />
                </th>
                <th>Job Role</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Date & Time</th>
                <th>Gender</th>
                <th>Experience</th>
                <th>Location</th>
                <th>Resume</th>
                <th>Shortlisted/Rejected</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </td>
                </tr>
              ) : (
                filteredApplications
                  .slice(startIndex, endIndex)
                  .map((application) => (
                    <tr
                      key={application.id}
                      className={
                        application.status === "Shortlist"
                          ? "shortlisted"
                          : application.status === "Reject"
                          ? "rejected"
                          : ""
                      }
                    >
                      <td>
                        {" "}
                        <input
                          type="checkbox"
                          checked={selectedApplications.includes(
                            application.id
                          )}
                          onChange={() => handleCheckboxChange(application.id)}
                        />
                      </td>
                      <td>{application.jobRole}</td>
                      <td>{application.name}</td>
                      <td>{application.email}</td>
                      <td>{application.number}</td>
                      <td>
                        {application.appliedOn &&
                          new Date(
                            application.appliedOn.toDate()
                          ).toLocaleString()}
                      </td>
                      <td>{application.gender}</td>
                      <td>{application.experience}</td>
                      <td>{application.location}</td>
                      <td>
                        {application.resume && (
                          <a
                            href={application.resume}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Resume
                          </a>
                        )}
                      </td>
                      <td>
                        <select
                          className="filter-section"
                          onChange={(e) =>
                            handleStatusChange(application.id, e.target.value)
                          }
                          value={application.status || ""}
                        >
                          <option value={""}>Select Status</option>
                          <option value={"Shortlist"}>Shortlisted</option>
                          <option value={"Reject"}>Rejected</option>
                        </select>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </>
      ) :
       showNewsletter ? (<>
       <h2 className="dashboard-h2">
            Newsletter Applications - {newsletterApplicants.length}
          </h2>
          <button className="export-button" onClick={exportNewsletterSelectedData}>
            Candidate Export <TfiExport />{" "}
            <span style={{ marginLeft: "5px" }}>
              {selectedNewsletter.length > 0
                ? selectedNewsletter.length
                : ""}{" "}
            </span>{" "}
          </button>
          <table className="applications-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={selectAllNewsletterHandler}
                    checked={allNewsletter || selectedNewsletter.length === newsletterApplicants.length}
                  />
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Message</th>
                <th>Company Name</th>
                <th>Date</th>

              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </td>
                </tr>
              ) : (
                newsletterApplicants
                  .slice(startIndex, endIndex)
                  .map((newsletter) => (
                    <tr
                      key={newsletter.id}
                    >
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedNewsletter.includes(newsletter.id)}
                          onChange={() => handleCheckboxNewsletterChange(newsletter.id)}
                        />
                      </td>
                      <td>{newsletter.name}</td>
                      <td>{newsletter.email}</td>
                      <td>{newsletter.message}</td>
                      <td>{newsletter.companyName}</td>
                      <td>{newsletter.date}</td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
       </>) :
      (
        <>
          <h2 className="dashboard-h2">
            Contact Applications - {contactApplicants.length}
          </h2>
          <button className="export-button" onClick={exportContactSelectedData}>
            Contact Export <TfiExport />{" "}
            <span style={{ marginLeft: "5px" }}>
              {selectedContacts.length > 0 ? selectedContacts.length : ""}{" "}
            </span>{" "}
          </button>
          <table className="contact-applicants-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={selectAllContactHandler}
                    checked={allContacted}
                  />
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Subject</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {contactApplicants.slice(startIndex, endIndex).map((contact) => (
                <tr key={contact.id}>
                  <td>
                    {" "}
                    <input
                      type="checkbox"
                      checked={selectedContacts.includes(contact.id)}
                      onChange={() => handleCheckboxContactChange(contact.id)}
                    />
                  </td>
                  <td>{contact.name}</td>
                  <td>{contact.email}</td>
                  <td>{contact.mobile}</td>
                  <td>{contact.subject}</td>
                  <td>{contact.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <GrPrevious />
        </button>
        <span>Page {currentPage}</span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={
            endIndex >=
            (showApplications
              ? filteredApplications.length
              : showNewsletter
              ? newsletterApplicants.length
              : contactApplicants.length)
          }
        >
          <GrNext />
        </button>
      </div>
    </div>
  );
};

export default Dashboard;
